module.exports = __webpack_public_path__ + "static/media/20240227114207_IMG_5530.a2a84c41.JPG";